<template>
    <div>
        <!-- @click="showModal" -->
        <div class="pop_open ms-2" data-bs-toggle="modal" data-bs-target="#chainlength">
            <div class="info_icon">
                <SvgHeaderSvg :type="'info'" />
            </div>
        </div>

        <Teleport  to="#teleports"> 
          <div class="modal fade" id="chainlength" data-bs-backdrop="true" tabindex="-1" aria-labelledby="chainlengthModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-lg">
                <div class="modal-content">
                  <div class="title_block">
                      <div>
                          <!-- <h3 class="mb-0" v-font="$getFont('NewYork', 600)">Get a gemologist opinion</h3> -->
                          <!-- <p>Prong tips are those small metal balls (either rounded, pointed, or split in two) on the surface of the diamond. There may be three, four, five, six, or eight prong tips holding your diamond in place depending on your design. All our designs come with white color prong tips by default. You can choose the color of the tip of your prong as per your preference.</p> -->
                      </div>
                      <span data-bs-dismiss="modal" aria-label="Close"><SvgHeaderSvg :type="'close'" class="largesvg"/></span>
                  </div>
                  <div class="modal-body">
                  <div class="row">

                    <div class="col-md-12 col-12 mb-5">
                      <h3 class="mb-0 font-active">Chain Length</h3>
                    </div>

                    <div class="col-md-8 col-12 mb-5 text-center mx-auto">
                      <picture class="mx-auto">
                          <source width="720" height="720" type="image/webp" srcset="~/assets/prong/chain_length.webp">
                          <img width="720" height="720" type="image/jpeg" src="~/assets/prong/chain_length.jpg" alt="Chain Length">
                      </picture>
                      <p class="text-center mt-4">Choose from a variety of chain lengths to have your necklace sized according to your preferred style or neckline. The popular necklace lengths include Collar length (14''), Choker length (16''), Princess length (18''), and Matinee length (20'').</p>
                    </div>
                  </div>
                  </div>
                
                </div>
              </div>
          </div>
        </Teleport>
    </div>    
</template>

<script setup>

</script>


<style scoped>
.largesvg {
    transform: scale(1.3);
    }
.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.modal-content{
  padding: 16px;
}
span{
    padding: 1%;
    color: #ccc;
    font-size: 14px;
    font-weight: 600;
}
  .gemo_box{
      cursor: pointer;
  }
  .title_block{
    /* display: flex;
    align-items: flex-start;
    justify-content: space-between; */
    text-align: right;
  }
  .modal-body {
    padding: 0 12px;
  }
  p {
    font-size: 14px;
    margin-bottom: 0;
    padding-top: 9px;
    color: #606060;
    font-weight: 400;
}
  .title_block span {
      cursor: pointer;
  }
   h3{
      font-size: 24px;
      text-align: center;
      color: #212529;
  }
  .drop_hint{
    cursor: pointer;
  }
  @media(max-width: 767px){
    h5{
        font-size: 16px;
    }
  }
</style>